import { DataBean } from "../DataBean";

export class OfficeRole extends DataBean {

    public async getOfficeRoleCatalog(idOffice: any, idRole: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getOfficeRoleCatalog_Number_Number_Number_Number", [idOffice, idRole, page, recordsPerPage]);
    }

    public async addOfficeRole(idOffice: any, idRole: any, idEmployee: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.admin.OfficeRole_addOfficeRole_Number_Number_Number", [idOffice, idRole, idEmployee]);
    }
    public async deleteOfficeRole(idOfficeRole: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteOfficeRole_Number", [idOfficeRole]);
    }
}